/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import {
  Autocomplete,
  Button,
  Card,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import Iconify from "../../../../components/iconify";
import { Helmet } from "react-helmet-async";
import Styles from "./styles";
import { useNavigate } from "react-router-dom";
import TexBoxWithLabel from "../../../../components/text-field";
import { useLocation } from "react-router-dom";
import APIS from "../../../../config/api";
import { GET, POST, PUT } from "../../../../config/https";
import Color from "../../../../theme/color";
import ValidationError from "../../../../components/validation-error-label";
import FullScreenLoader from "../../../../components/full-screen-loader";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { STRING } from "../../../../resources/string";
import { isEmpty } from "lodash";
import { isValidEmail } from "../../../../utils/validator";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toast } from "react-hot-toast";
import { marginBottomSize } from "../../../../utils/constant";
import { IMaskInput } from "react-imask";
import { GetLocalStorage } from "../../../../utils/local-storage";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
}

const AmountMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, name, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="$num"
        unmask={true}
        blocks={{
          num: {
            mask: Number,
            scale: 2,
            radix: ".",
            max: 999999,
            mapToRadix: ["."],
            thousandsSeparator: ",",
          },
        }}
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: name, value } })}
        overwrite
      />
    );
  }
);
interface CustomPercentageProps {
  onChange: (event: { target: { name: any; value: any } }) => void;
  name: any;
}

const PercentageMaskCustom = React.forwardRef<
  HTMLInputElement,
  CustomPercentageProps
>(function TextMaskCustom(props, ref) {
  const { onChange, name, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask="d%"
      unmask={true}
      lazy={false}
      blocks={{
        d: {
          mask: Number,
          scale: 2,
          radix: ".",
          min: 0,
          max: 100,
          expose: true,
        },
      }}
      inputRef={ref}
      onAccept={(value: any) => onChange({ target: { name: name, value } })}
      overwrite
    />
  );
});

const updateCouponData = {
  couponCode: "",
  discountTypeId: 2,
  discountTypeName: null,
  amount: null,
  percentage: null,
  minimumSpend: null,
  maximumSpend: null,
  limitPerCoupon: null,
  whiteListEmails: [],
  eventId: null,
  expiredOn: "",
  eventName: "",
  ticketType: [],
  ticketTypeLabel: [],
};

const data: any = [
  { title: "Fix Cart Discount", id: 1 },
  {
    title: "Percentage Discount",
    id: 2,
  },
];

export default function AddCoupon() {
  const location: any = useLocation();
  const couponId = location?.state?.couponId;
  const isEditable = location?.state?.isEditable;
  const [isValidation, setIsValidation] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<any, string>>({});
  const [loader, setLoader] = useState(false);
  const [eventList, setEventList] = useState<any>([]);
  const [ticketTypeList, setTicketTypeList] = useState<any>([]);
  const [discountType] = useState(data);
  const [updateCoupon, setUpdateCoupon] = useState<any>(updateCouponData);
  const navigate = useNavigate();
  const [eId, setEId] = useState<any>();
  const [DTId, setDTId] = useState<any>();
  const [oldCouponData, setOldCouponData] = useState<any>({});
  const eventLists = eventList?.map((x: any, index: any) => x.title);
  const discountTypes = discountType?.map((x: any, index: any) => x.title);
  const [inputValue, setInputValue] = useState<string>("");
  const [whiteListEmail, setWhiteListEmail] = useState<string[]>([]);
  const [whiteListEmailError, setWhiteListEmailError] = useState<string | null>(
    null
  );
  const [initialOptions, setInitialOptions] = useState(eventList);
  const [filteredOptions, setFilteredOptions] = useState(eventList);
  let userData = GetLocalStorage("loginData");
  const [selectedOrganizers] = useState({
    value: "",
    label: "",
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleWhiteListEmail = () => {
    const trimmedWhiteListEmail = inputValue.trim();

    if (!trimmedWhiteListEmail) {
      setWhiteListEmailError("Please enter valid email.");
      return;
    }

    if (!isValidEmail(trimmedWhiteListEmail)) {
      setWhiteListEmailError(
        "Invalid Email format for a Email EX.( xyz@email.com )."
      );
      return;
    }
    if (isEditable) {
      let newValue = { ...updateCoupon };
      let temp = {
        email: trimmedWhiteListEmail,
        id: 0,
      };
      newValue?.whiteListEmails?.push(temp);
      setUpdateCoupon(newValue);
    } else {
      let newWhiteListEmail = { ...updateCoupon };
      let temp = {
        email: trimmedWhiteListEmail,
      };
      newWhiteListEmail?.whiteListEmails?.push(temp);
      setWhiteListEmail(newWhiteListEmail);
    }
    setInputValue("");
    setWhiteListEmailError(null);
  };

  const handleRemoveWhiteListEmail = (emailToRemove: any) => {
    if (isEditable) {
      let newValue: any = { ...updateCoupon };
      let newEmailArray = newValue?.whiteListEmails?.filter(
        (data: any) => data?.id !== emailToRemove
      );
      if (newValue?.whiteListEmails !== undefined) {
        newValue.whiteListEmails = newEmailArray;
      }
      setUpdateCoupon(newValue);
    }

    const updatedWhiteListEmail = whiteListEmail?.filter(
      (email) => email !== emailToRemove
    );

    setWhiteListEmail(updatedWhiteListEmail);
  };
  useEffect(() => {
    setInitialOptions(eventList);
    setFilteredOptions(eventList);
  }, [eventList]);
  useEffect(() => {
    if (isEditable && oldCouponData) {
      GetCouponId();
    }
  }, []);

  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [updateCoupon, oldCouponData]);

  useEffect(() => {
    GetEventDropdown();
    if (isEditable && oldCouponData) {
      let newUpdateCoupon: any = { ...updateCoupon };
      newUpdateCoupon.amount = oldCouponData.amount;
      newUpdateCoupon.couponCode = oldCouponData.couponCode;
      newUpdateCoupon.discountTypeId = oldCouponData.discountTypeId;
      newUpdateCoupon.eventId = oldCouponData.eventId;
      newUpdateCoupon.expiredOn = oldCouponData.expiredOn;
      newUpdateCoupon.limitPerCoupon = oldCouponData.limitPerCoupon;
      newUpdateCoupon.maximumSpend = oldCouponData.maximumSpend;
      newUpdateCoupon.minimumSpend = oldCouponData.minimumSpend;
      newUpdateCoupon.percentage = oldCouponData.percentage;
      newUpdateCoupon.whiteListEmails = oldCouponData.whiteListEmails;
      newUpdateCoupon.eventName = oldCouponData?.event?.title;
      newUpdateCoupon.discountTypeName = oldCouponData?.discountTypeName;
      newUpdateCoupon.ticketType = oldCouponData.ticketType;
      newUpdateCoupon.ticketTypeLabel = oldCouponData?.ticketTypes;

      setUpdateCoupon(newUpdateCoupon);
      setEId(oldCouponData.eventId);
    } else {
      updateCoupon.eventId = "";
      updateCoupon.eventName = "";
      updateCoupon.couponCode = "";
      updateCoupon.discountTypeId = 2;
      updateCoupon.discountTypeName = "";
      updateCoupon.amount = null;
      updateCoupon.percentage = null;
      updateCoupon.expiredOn = "";
      updateCoupon.limitPerCoupon = null;
      updateCoupon.maximumSpend = null;
      updateCoupon.minimumSpend = null;
      updateCoupon.whiteListEmails = [];
      updateCoupon.ticketType = [];
      updateCoupon.ticketTypeLabel = [];
      setEId(updateCoupon.eventId);
    }
  }, [oldCouponData]);

  const EventOrganizerId = selectedOrganizers?.value;

  const getOrganizerId = () => {
    if (EventOrganizerId) {
      return EventOrganizerId;
    }
    if (!EventOrganizerId && userData?.roles?.id === 1) {
      return "";
    }
    if (!EventOrganizerId && userData?.roles?.id === 2) {
      return userData?.id;
    }
  };

  const GetEventDropdown = async () => {
    setLoader(true);
    let organizerId = await getOrganizerId();
    await GET(APIS.GET_ALL_EVENTS + "?OrganizerId=" + organizerId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setEventList(res.result);
        } else {
          // toast.error(res?.errors[0]);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (eId) {
      GetTicketTypeDropdown();
    }
  }, [eId]);

  const GetTicketTypeDropdown = async () => {
    setLoader(true);

    await GET(APIS.GET_ALL_EVENT_TICKET_CONFIG + "?eventId=" + eId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setTicketTypeList(res.result);
        } else {
          setTicketTypeList([]);
          toast.error(res?.errors[0]);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const GetCouponId = async () => {
    await GET(APIS.GET_COUPON_BY_ID + couponId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setOldCouponData(res.result);
        } else {
          // toast.error(res?.errors[0]);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const AddCoupon = async () => {
    setIsValidation(true);
    if (!validator()) return;
    setLoader(true);
    const percentageValue = DTId === 1 ? 0 : updateCoupon.percentage || 0;
    const amountValue = DTId === 2 ? 0 : updateCoupon.amount || 0;
    let param = {
      couponCode: updateCoupon.couponCode,
      discountTypeId: DTId || 2,
      amount: amountValue,
      ticketType: updateCoupon.ticketType,
      percentage: percentageValue,
      minimumSpend: updateCoupon.minimumSpend ? updateCoupon.minimumSpend : 0,
      maximumSpend: updateCoupon.maximumSpend ? updateCoupon.maximumSpend : 0,
      limitPerCoupon: updateCoupon.limitPerCoupon,
      whiteListEmails: updateCoupon.whiteListEmails,
      expiredOn: updateCoupon.expiredOn,
      eventId: eId,
    };

    await POST(APIS.ADD_COUPON_DETAIL, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          toast.success("Coupon Created");
          navigate("/dashboard/coupons");
        } else {
          // toast.error(res?.errors[0]);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoader(false);
        setIsValidation(false);
      });
  };

  const UpdateCoupon = async () => {
    setIsValidation(true);
    if (!validator()) return;

    const param = {
      id: couponId,
      couponCode: updateCoupon.couponCode,
      discountTypeId: updateCoupon.discountTypeId,
      amount: updateCoupon.amount || 0,
      percentage: updateCoupon.percentage || 0,
      minimumSpend: updateCoupon.minimumSpend ? updateCoupon.minimumSpend : 0,
      maximumSpend: updateCoupon.maximumSpend ? updateCoupon.maximumSpend : 0,
      limitPerCoupon: updateCoupon.limitPerCoupon,
      whiteListEmails: updateCoupon.whiteListEmails,
      ticketType: Array.isArray(updateCoupon.ticketType)
        ? updateCoupon.ticketType
        : JSON.parse(updateCoupon.ticketType),
      expiredOn: updateCoupon.expiredOn,
      eventId: eId,
    };
    await PUT(APIS.UPDATE_COUPON + "/" + couponId, param)
      .then(async (res: any) => {
        if (res?.isSuccess) {
          toast.success("Coupon Updated Successfully");

          navigate("/dashboard/coupons");
        }
      })
      .catch((error) => {
        console.log("error", error);

        setIsValidation(false);
      });
  };

  const onChangeFormData = async (key: string, e: any) => {
    let newData = { ...updateCoupon };
    switch (key) {
      case "couponCode":
        newData.couponCode = e.target.value;
        break;
      case "couponAmount":
        newData.amount = e.target.value;
        break;
      case "percentage":
        newData.percentage = e.target.value;
        break;
      case "expiredOn":
        newData.expiredOn = e.$d.toLocaleString("en-US", { hour12: true });
        break;
      case "maximumSpend":
        newData.maximumSpend = e.target.value;
        break;
      case "minimumSpend":
        newData.minimumSpend = e.target.value;
        break;
      case "usageLimitPerCoupon":
        newData.limitPerCoupon = e.target.value;
        break;
      case "whiteListEmails":
        newData.whiteListEmails = e.target.value;
        break;
    }

    setUpdateCoupon(newData);
  };

  const onChangeEventName = (name: string) => {
    const isFind = eventList.find((item: any) => {
      return item.title && name && item.title.trim() === name.trim();
    });

    if (isFind) {
      setEId(isFind.id);
      const newUpdateData = { ...updateCoupon };
      newUpdateData.eventName = name;
      newUpdateData.eventId = isFind.id;
      setUpdateCoupon(newUpdateData);
    } else {
    }
  };

  const handleOnChangeDiscountType = (name: any) => {
    const isFind = discountType.find((item: any) => item.title === name);
    setDTId(isFind?.id);
    const newUpdateData = { ...updateCoupon };
    newUpdateData.discountTypeName = name;
    newUpdateData.discountTypeId = isFind?.id;
    setUpdateCoupon(newUpdateData);
  };

  const onChangeTicketType = (newValue: any) => {
    if (isEditable) {
      let newUpdateData = { ...updateCoupon };
      newUpdateData.ticketType = newValue?.map((x: any) => x.id);
      newUpdateData.ticketTypeLabel = newValue;
      setUpdateCoupon(newUpdateData);
    } else {
      let newUpdateData = { ...updateCoupon };
      newUpdateData.ticketType = newValue?.map((x: any) => x.id);
      newUpdateData.ticketTypeLabel = newValue;
      setUpdateCoupon(newUpdateData);
    }
  };

  const validator = () => {
    const errors: Record<string, string> = {};
    if (updateCoupon && isEmpty(updateCoupon?.eventName ?? "")) {
      errors.eventName = "Please select Event Name";
    }

    if (updateCoupon && updateCoupon.discountTypeId === 1) {
      if (updateCoupon?.amount <= 0) {
        errors.amount = "Please enter Coupon Amount";
      }
    } else if (updateCoupon && updateCoupon.discountTypeId === 2) {
      if (updateCoupon?.percentage <= 0) {
        errors.percentage = "Please enter Coupon Percentage";
      }
    }
    if (updateCoupon && isEmpty(updateCoupon?.couponCode ?? "")) {
      errors.couponCode = "Please enter Coupon Code";
    }
    if (updateCoupon && !updateCoupon.discountTypeId) {
      errors.discountTypeId = "Please select Discount Type";
    }
    if (updateCoupon && !updateCoupon?.expiredOn) {
      errors.expiredOn = "Please select Date";
    }
    if (updateCoupon && isEmpty(updateCoupon?.ticketTypeLabel ?? "")) {
      errors.ticketTypeLabel = "Please select Ticket Type";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const filtered = initialOptions.filter((option: any) =>
      checkLabel(option, "title")
        .toLowerCase()
        .includes(inputValue.toLowerCase())
    );
    setFilteredOptions(filtered);
  };
  function checkLabel(option: any, label: string) {
    if (label === "name") {
      return option?.name;
    }
    if (label === "displayName") {
      return option?.displayName;
    }
    if (label === "firstName") {
      return option?.firstName;
    }
    if (label === "companyName") {
      return option?.companyName;
    }
    if (label === "timeZoneName") {
      return option?.timeZoneName;
    }
    if (label === "title") {
      return option?.title;
    }
  }
  return (
    <>
      <Helmet>
        <title> User | EventPrix </title>
      </Helmet>

      <Container maxWidth={"xl"} style={{ marginBottom: marginBottomSize }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          {couponId === undefined ? (
            <Typography variant="h4" gutterBottom>
              Add Coupon
            </Typography>
          ) : (
            <Typography variant="h4" gutterBottom>
              Edit Coupon
            </Typography>
          )}

          <Button
            style={{ backgroundColor: Color.primary }}
            variant="contained"
            startIcon={<Iconify icon="ep:back" />}
            onClick={() => {
              navigate("/dashboard/coupons");
            }}
          >
            Back
          </Button>
        </Stack>

        <Card sx={{ padding: 5 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <FullScreenLoader open={loader} />

            <Grid item xs={12} sm={12} md={6}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={eventLists}
                value={updateCoupon?.eventName}
                defaultValue={updateCoupon?.eventName || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Event Name *"
                    value={updateCoupon?.eventName}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Event Name"
                    onChange={handleFilterChange}
                  />
                )}
                onChange={(e: any) => {
                  onChangeEventName(e.target.innerText);
                }}
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    style={{
                      ...props.style,
                      border: " 1px solid #acacac",
                    }}
                  />
                )}
                size="small"
              />
              <ValidationError formErrors={formErrors.eventName} />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TexBoxWithLabel
                size="small"
                placeholder="Ex:summer10"
                label="Coupon Code"
                multiline={true}
                style={Styles.labelTextBox}
                value={updateCoupon.couponCode}
                onChange={(event) => onChangeFormData("couponCode", event)}
              />
              <ValidationError formErrors={formErrors.couponCode} />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={discountTypes}
                value={
                  updateCoupon?.discountTypeId === 1
                    ? STRING.DISCOUNTTYPE.FIXCARTDISCOUNT
                    : STRING.DISCOUNTTYPE.PERCENTAGEDISCOUNT
                }
                defaultValue={updateCoupon?.discountTypeName || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Discount Type *"
                    value={updateCoupon?.discountTypeName}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Discount Type"
                  />
                )}
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    style={{
                      ...props.style,
                      border: " 1px solid #acacac",
                    }}
                  />
                )}
                onChange={(e: any) => {
                  handleOnChangeDiscountType(e?.target?.innerText);
                }}
                size="small"
              />
              <ValidationError formErrors={formErrors.discountTypeId} />
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              {Number(updateCoupon.discountTypeId) === 1 ? (
                <>
                  <TextField
                    size="small"
                    placeholder="$000"
                    label="Coupon Amount *"
                    fullWidth
                    variant="outlined"
                    value={updateCoupon?.amount?.toString()}
                    onChange={(event) =>
                      onChangeFormData("couponAmount", event)
                    }
                    id="formatted-text-mask-input"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputComponent: AmountMaskCustom as any,
                    }}
                  />

                  <ValidationError formErrors={formErrors.amount} />
                </>
              ) : (
                <>
                  <TextField
                    size="small"
                    placeholder="Ex: 10%"
                    label="Coupon Percentage *"
                    fullWidth
                    variant="outlined"
                    value={updateCoupon?.percentage?.toString()}
                    onChange={(event) => onChangeFormData("percentage", event)}
                    id="formatted-text-mask-input"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputComponent: PercentageMaskCustom as any,
                    }}
                  />

                  <ValidationError formErrors={formErrors.percentage} />
                </>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  sx={{
                    width: "100%",
                    "& label": {
                      color: "#000",
                    },
                  }}
                  slotProps={{
                    textField: { size: "small", error: false },
                  }}
                  label="Coupon Expiry Date *"
                  format="MMM DD, YYYY - h:mm A"
                  // disablePast
                  value={dayjs(updateCoupon?.expiredOn)}
                  onChange={(event) => onChangeFormData("expiredOn", event)}
                />
              </LocalizationProvider>

              <ValidationError formErrors={formErrors.expiredOn} />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={ticketTypeList}
                disableCloseOnSelect
                value={updateCoupon?.ticketTypeLabel || ""}
                getOptionLabel={(option: any) => option?.ticketType}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                renderOption={(props: any, option: any, { selected }) => {
                  return (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.ticketType}
                    </li>
                  );
                }}
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    style={{
                      ...props.style,
                      border: " 1px solid #acacac",
                    }}
                  />
                )}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      InputLabelProps={{ shrink: true }}
                      label="Ticket Type *"
                      placeholder="Ticket Type"
                    />
                  );
                }}
                onChange={(e, newValue: any) => {
                  onChangeTicketType(newValue);
                }}
                size="small"
              />
              <ValidationError formErrors={formErrors.ticketTypeLabel} />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                size="small"
                placeholder="$000"
                label="Minimum Spend"
                fullWidth
                variant="outlined"
                value={updateCoupon?.minimumSpend?.toString()}
                defaultValue={updateCoupon?.minimumSpend?.toString()}
                onChange={(event) => onChangeFormData("minimumSpend", event)}
                id="formatted-text-mask-input"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputComponent: AmountMaskCustom as any,
                }}
              />
              {/* <ValidationError formErrors={formErrors.minimumSpend} /> */}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                size="small"
                placeholder="$000"
                label="Maximum Spend"
                fullWidth
                variant="outlined"
                value={updateCoupon?.maximumSpend?.toString()}
                defaultValue={updateCoupon?.maximumSpend?.toString()}
                onChange={(event) => onChangeFormData("maximumSpend", event)}
                id="formatted-text-mask-input"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputComponent: AmountMaskCustom as any,
                }}
              />
              {/* <ValidationError formErrors={formErrors.maximumSpend} /> */}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TexBoxWithLabel
                size="small"
                placeholder="Usage Limit Per Coupon"
                label="Usage Limit Per Coupon "
                types="number"
                style={Styles.labelTextBox}
                value={updateCoupon?.limitPerCoupon}
                defaultValue={updateCoupon?.limitPerCoupon}
                onChange={(event) =>
                  onChangeFormData("usageLimitPerCoupon", event)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="example@gmail.com"
                  label="Email"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleWhiteListEmail();
                    }
                  }}
                />
                {whiteListEmailError && (
                  <ValidationError formErrors={whiteListEmailError} />
                )}

                <Stack
                  spacing={1}
                  direction="row"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "start",
                    alignItems: "center",
                    maxWidth: "100%",
                  }}
                >
                  {updateCoupon?.whiteListEmails?.map(
                    (item: any, index: number) => {
                      return (
                        <Chip
                          style={{ margin: "5px" }}
                          key={index}
                          label={item.email}
                          onDelete={() => handleRemoveWhiteListEmail(item.id)}
                        />
                      );
                    }
                  )}
                </Stack>
              </div>

              <Typography>
                Enter a list of billing email addresses. Use an asterisk (*) to
                match parts of an email (e.g., '@gmail.com' matches all Gmail
                addresses).
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <div
                style={{
                  ...Styles.submitBtn,
                }}
              >
                <Button
                  variant="contained"
                  onClick={isEditable ? UpdateCoupon : AddCoupon}
                  style={{ backgroundColor: Color.primary }}
                >
                  {isEditable ? "Update Coupon" : "Create Coupon"}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </>
  );
}
